<template>
    <div class="club" v-if="cData.length > 0">
        <div class="maybeFollow">
            <div class="title ">你可能还关注：</div>
		</div>
        <ul class="hotHtList">
            <li class="hot-li" v-for="(item,index) in cData" :key="index" @mouseenter="changeList(index)">
                <p class="listTit" :class="`icon_num${index}`"><a :href="item.subjectUrl" target="_blank" @click="countAd(4506)">{{item.title}}</a></p>
                    <div class="List_con" v-show="currentList === index">
                        <a :href="item.subjectUrl" target="_blank"><img :src="item.logo" height="50" width="50" @click="countAd(4506)"></a>
                        <p class="readnums"><i>阅读数：</i> {{item.pvCount | thounds(1)}}</p>
                    </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Club',
        props: {
            clueData: {
                type: Array,
                default: () => ([])
            }
        },
        data() {
            return {
                currentList: 0, //当前第几个激活
                cData: [], //数据
            }
        },
        watch: {
            clueData(n) {
                this.cData = n
            }
        },
        filters: {
            thounds(n,tofixd) {
                let num;
                if(n > 9999){//大于9999显示x.xx万
                    num=((n/1000)/10).toFixed(tofixd) + '万';
                    }else if( n < 9999 && n>-9999){
                    num=n
                    }else if(n<-9999){//小于-9999显示-x.xx万
                    num = -((Math.abs(n/1000)/10).toFixed(tofixd))+'万'
                }
                return num;
            }
        },
        methods: {
            changeList(i) {
                this.currentList = i
            }
        },
    }
</script>

<style lang="scss" scoped>
.club {
    .maybeFollow {
        margin-bottom: 5px;
        .title {
            height: 27px;
            background: #f4f4f4;
            border-top: 1px solid #e0e0e0;
            line-height: 27px;
            color: #333333;
            font-weight: bold;
            padding-left: 10px;
        }
    }
    .hotHtList {
        .hot-li {
            .listTit {
                font-size: 14px;
                padding-left: 26px;
                line-height: 38px;
                a {
                    color: #225599;
                }
                &.icon_num0 {
                    background: url($imageURLIcon) no-repeat;
                    background-position: 0 12px;
                }
                &.icon_num1 {
                    background: url($imageURLIcon) no-repeat;
                    background-position: 0 -89px;
                }
                &.icon_num2 {
                    background: url($imageURLIcon) no-repeat;
                    background-position: 0 -128px;
                }
                &.icon_num3 {
                    background: url($imageURLIcon) no-repeat;
                    background-position: 0 -166px;
                }
                &.icon_num4 {
                    background: url($imageURLIcon) no-repeat;
                    background-position: 0 -205px;
                }
            }
            .List_con{
                display: flex;
                padding-left: 26px;
                a {
                    margin-right: 12px;
                    display: block;
                    width: 50px;
                    height: 50px;
                    img {
                        border: 0;
                        vertical-align: middle;
                    }
                }
                .readnums {
                    line-height: 50px;
                    text-align: center;
                    i {
                        color: #777;
                        font-style: normal;
                    }
                }
            } 
        }
    }
}
</style>